import { Box, Divider, FormControl, FormHelperText, Typography } from '@mui/material';

import React, { FC } from 'react';

const SummaryLine: FC<{ label: string; value: any, error?: boolean, errorMessage?: string }> = ({ label, value, error, errorMessage }) => {
	return (
		<FormControl sx={{ width: '100%' }} error={error}>
			<Box sx={{ display: 'flex', width: '100%' }}>
				<Typography sx={{ width: '50%', padding: '0.5rem 2rem 0.5rem 1rem' }} variant="body2">
					{label}
				</Typography>
				<Typography sx={{ fontWeight: 600, width: '50%', padding: '0.5rem 2rem' }} variant="body2">
					{value}
				</Typography>
			</Box>
			<FormHelperText sx={{ margin: '0.5rem 2rem' }}>
                {errorMessage}
            </FormHelperText>
			<Divider sx={{ width: '100%' }} />
		</FormControl>
	);
};
export default SummaryLine;
